"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseElasticsearchResult(elasticsearchResult) {
    return {
        scrollId: elasticsearchResult._scroll_id,
        documents: elasticsearchResult.hits.hits.map(doc => (Object.assign({}, doc._source, { id: doc._id, _id: doc._id }))),
        total: elasticsearchResult.hits.total
    };
}
function parseUserContentMetricsResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    if (elasticsearchResult.hits.hits.length > 20000) {
        throw new Error('Inefficient Request, Not Allowed..!!');
    }
    return { scrollId, userContentMetrics: documents, total };
}
exports.parseUserContentMetricsResult = parseUserContentMetricsResult;
function parseUsersResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, users: documents, total };
}
exports.parseUsersResult = parseUsersResult;
function parseLiveClassResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, liveClasses: documents, total };
}
exports.parseLiveClassResult = parseLiveClassResult;
function parseLiveClassEventsResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, liveClassEvents: documents, total };
}
exports.parseLiveClassEventsResult = parseLiveClassEventsResult;
function parseContentsResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    if (elasticsearchResult.aggregations) {
        const contentTypeAggregation = elasticsearchResult.aggregations.contentType.buckets;
        return { scrollId, contents: documents, total, contentTypeAggregation };
    }
    return { scrollId, contents: documents, total };
}
exports.parseContentsResult = parseContentsResult;
function parseLiveTrainingClassResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, liveClasses: documents, total };
}
exports.parseLiveTrainingClassResult = parseLiveTrainingClassResult;
function parseContentVersionLogsResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, contentVersionLogs: documents, total };
}
exports.parseContentVersionLogsResult = parseContentVersionLogsResult;
function parseStateInteractionsResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, stateInteractions: documents, total };
}
exports.parseStateInteractionsResult = parseStateInteractionsResult;
function parseStatesResult(elasticsearchResult) {
    const { scrollId, documents, total } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, states: documents, total };
}
exports.parseStatesResult = parseStatesResult;
function parseDashboardsResult(elasticsearchResult) {
    const { scrollId, documents = [], total = 0 } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, dashboards: documents, total };
}
exports.parseDashboardsResult = parseDashboardsResult;
function parseGroupsResult(elasticsearchResult) {
    const { scrollId, documents = [], total = 0 } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, groups: documents, total };
}
exports.parseGroupsResult = parseGroupsResult;
function parseAssignmentEventsResult(elasticsearchResult) {
    const { scrollId, documents = [], total = 0 } = parseElasticsearchResult(elasticsearchResult);
    return { scrollId, assignmentEvents: documents, total };
}
exports.parseAssignmentEventsResult = parseAssignmentEventsResult;
//# sourceMappingURL=parseElasticsearchResult.js.map